import type { ReactElement } from 'react';
import type { GateBannerData } from './types';

export interface GateBannerProps {
  data: GateBannerData;
  /** Fires when the viewer clicks the dismiss link or the popover closes. */
  onDismiss: () => void;
}

/**
 * Compact popover content for like / save / comment gates. Pairs
 * with `GatePopover` — it provides the portal + positioning; this
 * provides the body.
 */
export function GateBanner({ data, onDismiss }: GateBannerProps): ReactElement {
  return (
    <div className="tb-gate-banner">
      <span className="tb-gate-banner-eyebrow">{data.eyebrow}</span>
      <h3 className="tb-gate-banner-title">{data.title}</h3>
      <p className="tb-gate-banner-body">{data.body}</p>
      <div className="tb-gate-banner-actions">
        <a className="tb-gate-banner-cta" href={data.ctaHref}>
          {data.ctaLabel}
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            aria-hidden="true"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </a>
        {data.dismissLabel !== undefined ? (
          <button type="button" onClick={onDismiss} className="tb-gate-banner-dismiss">
            {data.dismissLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
